// Duplicate-client check for the Clients page (owner, 5 Nov 2026): a client already in the list is caught while the
// office types the UEN / company name, and can only be opened — never added again.
//
// normName mirrors the LIVE database function public.norm_company_name exactly (the rule quotation signing uses to
// find a client): upper case, "PRIVATE LIMITED" → "PTE LTD", anything not A–Z / 0–9 / space → space,
// whole-word "LIMITED" → "LTD", repeated spaces → one, trimmed.
export function normName(t) {
  return String(t || '').toUpperCase()
    .replace(/PRIVATE\s+LIMITED/g, 'PTE LTD')
    .replace(/[^A-Z0-9 ]/g, ' ')
    .replace(/\bLIMITED\b/g, 'LTD')
    .replace(/\s+/g, ' ')
    .trim()
}

// UEN as stored and compared: upper case, no spaces ("201912345k " → "201912345K").
export const normUen = u => String(u || '').replace(/\s+/g, '').toUpperCase()

// For the "Similar:" hint only (never blocks): the name without company-type words.
const core = t => normName(t).replace(/\b(PTE|LTD|PRIVATE|LIMITED|SINGAPORE|S|THE)\b/g, ' ').replace(/\s+/g, ' ').trim()

// Clients matching what was typed. selfId = the client being edited (never matches itself).
//   uen     — same UEN
//   name    — same company name (normName)
//   similar — one name contains the other (company-type words ignored); a hint, not a block
export function findClientMatches(clients, { uen, name }, selfId) {
  const others = (clients || []).filter(c => c && c.id !== selfId)
  const u = normUen(uen), n = normName(name), k = core(name)
  const byUen = u ? others.filter(c => normUen(c.uen) === u) : []
  const byName = n ? others.filter(c => normName(c.name) === n) : []
  const seen = new Set([...byUen, ...byName].map(c => c.id))
  const similar = k.length >= 4 ? others.filter(c => {
    if (seen.has(c.id)) return false
    const ck = core(c.name)
    return ck.length >= 4 && (ck.includes(k) || k.includes(ck))
  }).slice(0, 3) : []
  return { byUen, byName, similar }
}

// A genuine second company on a shared UEN (e.g. two Emerson entities) — allowed only when the name is clearly
// different from every client already on that UEN (not the same, and neither name contains the other).
export function clearlyDifferentName(name, clientsOnUen) {
  const k = core(name)
  if (k.length < 4) return false
  return (clientsOnUen || []).every(c => { const ck = core(c.name); return ck !== k && !ck.includes(k) && !k.includes(ck) })
}
